import React from 'react';
import SocialParade from 'src/components/social_parade/SocialParade';

type Props = {
  node: IStorageSocialParade;
};

const StorageSocialParade = ({ node: socialParade }: Props) => {
  return <SocialParade title={socialParade?.name ?? ''} />;
};

export default StorageSocialParade;
